import { ManageElement } from "./ManageElement";
import { BullpenSizeStore } from "stores/BullpenSizeStore";

export class BullpenSize extends ManageElement {
  static _store: BullpenSizeStore;
}
